import { Table } from "antd";
import { StandingColumns } from "~pages/Standings/enums/standingColumns";
import { useGetColumns } from "~pages/Standings/hooks/useGetColumns";
import type { StandingTransformed } from "~pages/Standings/types/standingTransformed";

type Props = {
  data?: Array<StandingTransformed>;
  isLoading?: boolean;
  selectedColumns?: string[];
  title?: string;
};

const StandingList = ({ data, isLoading, title, selectedColumns = [] }: Props) => {
  const columnsDefinition = useGetColumns();

  const columns = [...selectedColumns, StandingColumns.Actions]
    .filter((item) => columnsDefinition?.[item])
    .map((item) => columnsDefinition[item])
    .sort((a, b) => a.order - b.order);

  return (
    <span className="standing-list" style={{ marginBottom: 10, width: "100%" }}>
      <Table
        tableLayout="fixed"
        dataSource={data}
        loading={isLoading}
        size={"small"}
        rowKey={({ standingId }) => standingId}
        columns={columns}
        pagination={false}
        title={title ? () => title : undefined}
        scroll={{ x: "max-content" }}
      />
    </span>
  );
};

export default StandingList;
